/* eslint-disable */

import React from "react";
import {
  ShnoodleImage,
  ShnoodleImageType,
} from "../../../ui-components/shnoodle-image/shnoodle-image.tsx";
import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";

const ArticleBase = ({
  title,
  dateWrittenStr = "28 February 2025",
  minuteReadTime = 4,
  shnoodleType = ShnoodleImageType.WateringCan,
  children,
}) => {
  return (
    <div className="w-full items-center flex flex-col pt-10 gap-8 px-2">
      <RaindropBackButtonPanel />
      <ShnoodleImage shnoodleType={shnoodleType} />
      <div className="flex flex-col w-full items-center justify-center gap-2">
        <h1 className="text-4xl font-bold text-center">{title}</h1>

        <div className="flex flex-row gap-3 items-center font-bold text-sm text-color-dark-text-secondary">
          <h4>{dateWrittenStr}</h4>
          <div className="aspect-square w-1 bg-white rounded-full" />
          <h3>{minuteReadTime} minute read</h3>
        </div>
      </div>

      <div className="flex flex-col text-left w-full text-xl py-12">
        {children}
      </div>
    </div>
  );
};

export default ArticleBase;
